import { render, staticRenderFns } from "./resultInfo.vue?vue&type=template&id=1d7bd902&scoped=true&"
import script from "./resultInfo.vue?vue&type=script&lang=js&"
export * from "./resultInfo.vue?vue&type=script&lang=js&"
import style0 from "./resultInfo.vue?vue&type=style&index=0&id=1d7bd902&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7bd902",
  null
  
)

export default component.exports